import { get } from './P3Api';

class CategoryGroupApi {
  static async getCategoryGroups(categoryId) {
    return get(`categories/${categoryId}/groups`);
  }
}

export default CategoryGroupApi;
